import actions from '../../actionTypes';

export default id => {
  return {
    type: actions.GET_USER,
    id
  };
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/getUser.js